import { Close } from "@material-ui/icons";
import { AppBar, Grid, IconButton, styled, Typography } from "@mui/material";
import { useHistory } from "react-router";

const PreviewAppBar = () => {
  const history = useHistory();
  return (
    <CustomAppBar>
      <Grid container columnSpacing={2}>
        <Grid item>
          <IconButton onClick={() => history.goBack()}>
            <Close />
          </IconButton>
        </Grid>
        <Grid item>
          <Typography fontSize={25}>Preview</Typography>
        </Grid>
      </Grid>
    </CustomAppBar>
  );
};
const CustomAppBar = styled(AppBar)({
  backgroundColor: "#f5f5f5",
  color: "black",
  boxShadow: "none",
  borderBottom: "1px solid #e0e0e0",
  padding: "16px 24px",
});

export default PreviewAppBar;
